module.exports = __webpack_public_path__ + "img/Dantam Hair 15.8ae50991.jpg";